import React, { useState } from "react";
import LayoutSiderBar from "../../sidenavigation/layoutSidebar";
import Topnav from "../../topnav/topnav";
import "./mainLayout.css";
import SideBar from "../sidebar-v2/sidebar";

const MainLayout = ({ children }) => {
  const [open, setOpen] = useState(false);

  const handleSidebarClose = () => {
    setOpen(false);
  };
  return (
    <div className="main-layout-main flex-wrap d-flex">
      <Topnav open={open} setOpen={setOpen} />
      <div className="main-layout-container fn_Nunito d-flex flex-row w-100">
        <SideBar open={open} setOpen={setOpen} />
        <main className="d-flex flex-column w-100 main-container">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
